import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as Website from '../Config/Website.js';


const Section = () => {
  gsap.registerPlugin(ScrollTrigger);
  // gsap.matchMedia().add("(min-width: 767px)", () => {
  //   ScrollTrigger.create({
  //     trigger: ".js-stickyCm",
  //     start: "top 0%",
  //     end: "bottom 0%",
  //     toggleClass: "is-active",
  //     pin: true,
  //     // markers: true,
  //   });
  // });
  ScrollTrigger.create({
    trigger: ".js-musicSection",
    start: "top 65%",
    end: "bottom 25%",
    toggleClass: "is-active",
    // markers:true,
  });
  ScrollTrigger.create({
    trigger: ".js-locationSection",
    start: "top 50%",
    end: "bottom 0%",
    toggleClass: "is-active",
    // markers:true,
  });
}

const init = () => {
  Section();
}
export default init;